var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.665 187.5H33.332V12.5H124.999L166.665 54.1667V187.5Z",
    fill: "#FF5722"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.415 58.3333H120.832V18.75L160.415 58.3333Z",
    fill: "#FBE9E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.875 122.917V137.5H57.5V96.0293H71.6292C75.7292 96.0293 79.0042 97.3043 81.4417 99.846C83.8792 102.388 85.1 105.692 85.1 109.758C85.1 113.825 83.8917 117.029 81.4833 119.388C79.075 121.746 75.7292 122.917 71.4542 122.917H65.875ZM65.875 115.938H71.6292C73.225 115.938 74.4583 115.417 75.3333 114.371C76.2083 113.325 76.6417 111.808 76.6417 109.813C76.6417 107.742 76.1958 106.096 75.3042 104.867C74.4125 103.646 73.2167 103.025 71.7167 103.004H65.875V115.938ZM90.6833 137.5V96.0293H101.65C106.492 96.0293 110.354 97.5668 113.225 100.642C116.104 103.717 117.571 107.933 117.629 113.288V120.008C117.629 125.458 116.187 129.738 113.317 132.838C110.433 135.95 106.471 137.5 101.421 137.5H90.6833ZM99.0542 103.008V130.55H101.562C104.354 130.55 106.321 129.813 107.458 128.342C108.596 126.871 109.196 124.333 109.254 120.725V113.521C109.254 109.646 108.712 106.946 107.629 105.421C106.546 103.892 104.704 103.088 102.104 103.013H99.0542V103.008ZM145.029 120.579H132.012V137.5H123.637V96.0293H146.596V103.008H132.012V113.633H145.029V120.579Z",
    fill: "#FFEBEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfThumbnail);
export default __webpack_public_path__ + "static/media/pdf-thumbnail.303d2b8da2d4e3962eaa1f70722e9a4b.svg";
export { ForwardRef as ReactComponent };